(() => {
	const svg = document.querySelector('.municipalities svg');
	const jsonElement = document.getElementById('zones-json');

	if(!svg || !jsonElement) return;

	const municipalities = JSON.parse(jsonElement.textContent);

	let top = null;
	let bottom = null;
	let left = null;
	let right = null;

	// Calculate the boundries of the valid zones
	for(const code in municipalities) {
		const el = svg.querySelector(`[data-code="${code}"]`);

		if(!el) continue;

		el.classList.add('valid');

		const rect = el.getBBox();

		top = (top === null ? rect.y : Math.min(top, rect.y));
		bottom = (bottom === null ? (rect.y + rect.height) : Math.max(bottom, (rect.y + rect.height)));
		left = (left === null ? rect.x : Math.min(left, rect.x));
		right = (right === null ? (rect.x + rect.width) : Math.max(right, (rect.x + rect.width)));
	}

	// Adjust boundries so that we don't get clipped edges
	const islands = svg.querySelectorAll('.island');

	for(const island of islands) {
		if(!island.querySelectorAll('.valid').length) {
			island.style.display = 'none';
			continue;
		}

		const paths = island.querySelectorAll('path');

		for(const path of paths) {
			const rect = path.getBBox();
	
			if(rect.y > bottom) continue;
			if(rect.y + rect.height < top) continue;
	
			if(rect.x < left) left = rect.x;
			if(rect.x + rect.width > right) right = rect.x + rect.width;
		}
	}

	svg.setAttribute('viewBox', `${left} ${top} ${right - left} ${bottom - top}`);

	const label = document.createElement('div');
	label.className = 'eriks-zones-label';
	document.body.appendChild(label);

	svg.addEventListener('mousemove', e => {
		label.style.left = e.x + 'px';
		label.style.top = e.y + 'px';

		const municipality = getMunicipality(e.target);

		label.innerText = (municipality ? municipality.name : '');
	});

	svg.addEventListener('click', e => {
		const municipality = getMunicipality(e.target);

		if(municipality) {
			document.location = municipality.url;
		}
	});

	function getMunicipality(el) {
		if(!el.classList.contains('valid')) return null;

		return municipalities[el.getAttribute('data-code')] || null;
	}

	document.querySelector('.zones .content').addEventListener('click', e => {
		if(!e.target.classList.contains('expandable')) return;

		e.target.classList.toggle('expanded')
	})

	// console.log(svg.getBBox());

	// console.log(top, bottom);
})();